<ng-container *ngIf="type && key">
  <div class="row margin-bottom-lg">
    <div
      class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12 margin-bottom-lg">
      <p-card [header]="'{{type.name}} - {{keyName}}' | translation">
        <div>
          <div class="key-item row body">
            <div class="col-md-11 col-sm-8 col-xs-6 vertical-center">
              <strong>{{ 'item_submit_edit' | translation }}:</strong>
            </div>
            <div class="col-md-1 col-sm-4 col-xs-6 content-center">
              <button
                pButton
                size="small"
                [rounded]="true"
                *ngIf="!key.item_desc.write"
                (click)="openItemDialog('write')"
                severity="primary">
                <i class="fas fa-plus"></i>
              </button>
              <button
                pButton
                size="small"
                [rounded]="true"
                *ngIf="key.item_desc.write"
                (click)="editExpand = !editExpand"
                severity="primary">
                <i class="fas fa-pencil-alt" *ngIf="!editExpand"></i>
                <i class="fas fa-chevron-up" *ngIf="editExpand"></i>
              </button>
            </div>
            <div *ngIf="editExpand">
              <div *ngIf="key.item_desc.write">
                <div class="col-sm-10 margin-bottom-std">
                  <app-controls
                    *ngFor="
                      let control of settings[key.item_desc.write.type].settings
                    "
                    [item]="control"
                    [selectedItem]="key.item_desc.write"
                    [parentView]="key.item_desc.write"></app-controls>
                </div>
                <div class="col-sm-10 margin-bottom-std">
                  <app-items [item]="key.item_desc.write"></app-items>
                </div>
                <div class="col-sm-12">
                  <button
                    pButton
                    severity="primary"
                    (click)="openItemDialog('write')">
                    {{ 'change' | translation }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="key-item row striped">
            <div class="col-md-11 col-sm-8 col-xs-6">
              <strong>{{ 'item_read' | translation }}:</strong>
            </div>
            <div class="col-md-1 col-sm-4 col-xs-6 content-center">
              <button
                pButton
                size="small"
                [rounded]="true"
                *ngIf="!key.item_desc.read"
                (click)="openItemDialog('read')"
                severity="primary">
                <i class="fas fa-plus"></i>
              </button>
              <button
                pButton
                size="small"
                [rounded]="true"
                *ngIf="key.item_desc.read"
                (click)="readExpand = !readExpand"
                severity="primary">
                <i class="fas fa-pencil-alt" *ngIf="!readExpand"></i>
                <i class="fas fa-chevron-up" *ngIf="readExpand"></i>
              </button>
            </div>

            <div *ngIf="readExpand">
              <div *ngIf="key.item_desc.read">
                <div class="col-sm-10 margin-bottom-std">
                  <app-controls
                    *ngFor="
                      let control of settings[key.item_desc.read.type].settings
                    "
                    [item]="control"
                    [selectedItem]="key.item_desc.read"
                    [parentView]="key.item_desc.read"></app-controls>
                </div>
                <div class="col-sm-10 margin-bottom-std">
                  <app-items [item]="key.item_desc.read"></app-items>
                </div>
                <div class="col-sm-12">
                  <button
                    pButton
                    severity="primary"
                    (click)="openItemDialog('read')">
                    {{ 'change' | translation }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-11 col-sm-8 col-xs-6">
              <strong>{{ 'encrypt_keys' | translation }}:</strong>
            </div>
            <div class="col-md-1 col-sm-4 col-xs-6 content-center">
              <scaffold-toggle-slide
                status="primary"
                [checked]="checked"
                [disabled]="!key.can_edit"
                [(ngModel)]="key.encrypted"
                (ngModelChange)="keyUpdated = true">
              </scaffold-toggle-slide>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 striped">
              <strong>{{ 'name_friendly' | translation }}:</strong>
            </div>
            <div class="col-md-6 striped">
              <input
                pInputText
                class="lms-input float-right col-md-8"
                type="text"
                (ngModelChange)="keyUpdated = true"
                [disabled]="!key.can_edit"
                [(ngModel)]="key.json_data.friendlyName" />
            </div>
          </div>
          <div
            class="row"
            *ngFor="let lms of lmsList; let oddRow = odd"
            [class.striped]="oddRow">
            <div class="col-md-6">
              <strong>{{ lms }}:</strong>
            </div>
            <div class="col-md-6">
              <input
                pInputText
                class="lms-input float-right col-md-8"
                type="text"
                (ngModelChange)="keyUpdated = true"
                [disabled]="!key.can_edit"
                [(ngModel)]="key.json_data[lms]" />
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 col-md-offset-2">
      <button pButton severity="secondary" (click)="location.back()">
        {{ 'cancel' | translation }}
      </button>
      <button
        pButton
        severity="primary"
        (click)="saveKey()"
        [disabled]="!keyUpdated && !componentUpdated()">
        {{ 'save' | translation }}
      </button>
    </div>
  </div>
</ng-container>
